
export default {
  name: 'CoreInputCheck',
  model: {
    prop: 'modelValue',
    event: 'change',
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    modelValue: {
      default: '',
    },

    value: { type: String, default: '' },

    trueValue: { type: Boolean, default: true },
    falseValue: { type: Boolean, default: false },

    disabled: {
      type: Boolean,
      default: false,
    },

    prevent: {
      type: Boolean,
      default: false,
    },

    checked: {
      type: Boolean,
      default: false,
    },

    id: {
      type: [String, Number],
      required: true,
    },

    name: {
      type: [String, Number],
      default: null,
    },

    label: {
      type: String,
      required: true,
    },

    classes: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      isFocus: false,
    }
  },
  computed: {
    isChecked() {
      if (this.modelValue instanceof Array) {
        return this.modelValue.includes(this.value)
      }
      // Note that `true-value` and `false-value` are camelCase in the JS
      return this.modelValue === true
    },
  },
  methods: {
    updateInput(event) {
      const isChecked = event.target.checked
      if (this.modelValue instanceof Array) {
        const newValue = [...this.modelValue]
        if (isChecked) {
          newValue.push(this.value)
        } else {
          newValue.splice(newValue.indexOf(this.value), 1)
        }
        this.$emit('change', newValue)
      } else {
        this.$emit('change', isChecked ? this.trueValue : this.falseValue)
      }
    },
  },
}
